import { generatePath } from "react-router-dom";
import { routeURLs } from "../../../../../../../../utils/enums";
import { tViews } from "../../../../../../../../utils/table";


const redirectToTrend = (model, navigate, site) => {
  localStorage.setItem("tunnel_details", JSON.stringify(model));
  navigate(generatePath(routeURLs.adSingleSiteTrend, { siteName: site, tunnelName: model.tunnel_name }));
}

export const getColumns = (navigate, site, openTableSettings) => {
    return [
          { 
            id:'remote_site_name_col',
            prop:'remote_site_name',
            get name() { return tViews('adSites.tunnel_summary.label.remoteSite')},
            sortable: true,
            size: 120
          },
          { 
            id:'remote_site_city_col',
            prop:'remote_site_city',
            get name() { return tViews('adSites.tunnel_summary.label.remoteLocation')},
            sortable: true,
            size: 135
          },
          { 
            id:'circuit_name_col',
            prop:'circuit_name',
            get name() { return tViews('adSites.tunnel_summary.label.circuitName')},
            sortable: true,
            size: 200
          },
          {
            id:'tunnel_name_col',
            prop:'tunnel_name',
            get name() { return tViews('adSites.tunnel_summary.label.tunnelName')},
            sortable: true,
            size: 450,
            cellTemplate: (createElement, prop) => {
              return createElement("hbr-link", 
              {
                "onHbr-focus": (e) => {
                  e.preventDefault()
                  redirectToTrend(prop.model, navigate, site)
                },
                "aria-label": tViews('tunnelDetailswithName', {name: prop.model.tunnel_name}),
                tabIndex: 0,
                role: "link"
              }, prop.model.tunnel_name);
            },
            cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}` })
          },
          {
            id:'anomaly_rate_col',
            prop:'anomaly_rate',
            get name() { return tViews('adSites.tunnel_summary.label.anomalyRate')},
            sortable: true,
            size: 160
          },
          { 
            id:'display_app_usage_col',
            prop:'display_app_usage',
            get name() { return tViews('adSites.tunnel_summary.label.tunnelUsage')},
            sortable: true,
            size: 150
          },
          {
            id:'app_cnt_col',
            prop:'app_cnt',
            get name() { return tViews('adSites.tunnel_summary.label.applications')},
            sortable: true,
            size: 120
          },
          {
            id:'local_service_provider_col',
            prop:'local_service_provider',
            get name() { return tViews('adSites.tunnel_summary.label.localServiceProvider')},
            sortable: true,
            size: 300
          },
          {
            id:'remote_service_provider_col',
            prop:'remote_service_provider',
            get name() { return tViews('adSites.tunnel_summary.label.remoteServiceProvider')},
            sortable: true,
            size: 450
          },
          {
            id: "actions_col",
            prop: "actions",
            name: "Actions",
            hiddenText: "Actions",
            disableToggle: true,
            sortable: false,
            headerSlot: false,
            pin: "colPinEnd",
            size: 70,
            columnTemplate: (createElement) => {
              return createElement("hbr-icon-button", {
                name: "gear-six-outlined",
                class: "hbr-css__table-cell-align-center gear-icon",
                aria: { label: tViews('tableSettings') || "Table settings" },
                "data-testid": "setting-ad-single-site-table",
                onClick: (evt) => {
                  evt.stopPropagation();
                  openTableSettings();
                }
              });
            }
          }
    ]
}
